module.exports = __webpack_public_path__ + "static/media/83.f277b25a.webp";